<template>
  <div class="voting_wrap">
    <img class="share_btn" src="https://images.zhibo.tv/2021/0721/share_icon.png" @click="share" alt="">
    <div class="voting_title">
      <img src="https://images.zhibo.tv/2021/0722/voting_ttile_bj2.png" alt="">
    </div>
    <div class="hint_content">
      <span>活动说明</span>
      <p>每位用户每天最多可投3票，投票截止后选取10位用户赠送国乒选手签名照片，为取得票数前三选项中投票最多的前100位用户瓜分50000播币。</p>
    </div>
    <div class="athletes_voting">
      <ul>
        <li v-for="(item, index) in playerlist" :key="index">
           <div class="left_athletes">
             <span>{{index + 1}}</span>
           </div>
           <div class="center">
            <div class="voting_num">
              <img src="https://images.zhibo.tv/2021/0721/voting_succes_icon.png" alt="">
              <span>{{item.vote_num}}</span>
            </div>
            <div class="player_box">
              <img :src="item.player_img" alt="">
              <span>{{item.player_name}}</span>
            </div>
           </div>
           <div class="right">
            <span @click="voteGo(item)">为TA投票</span>
           </div>
        </li>
      </ul>
    </div>
    <div class="activity_ended_description">
      <span>投票截止时间：2021年8月8日</span>
      <span>本活动最终解释权归「中国体育」ZHIBO.TV所有</span>
    </div>
    <div class="footer_chinasports_icon">
      <img src="https://images.zhibo.tv/2021/0722/china_sports_icon.png" alt="">
    </div>
    <hintMark v-if="toggleMark" @close="toggle" :type="showType" :count="count" sourceType="2"></hintMark>
  </div>
</template>
<script>
import hintMark from './hintMark.vue'
import {ADDRESS} from '../../config/address'
import { Toast } from "vant"
export default {
  data() {
    return {
      toggleMark: false,
      showType: '3',
      count: 2,
      playerlist: [],
      combat_vote_id: '',
      award_type: '',
      shareInfo: {}
    }
  },
  components: {
    hintMark
  },
  created() {
    this.token = this.$route.query.token || ''
    this.getAwardList()
  },
  methods: {
    // 切换弹框显示
    toggle() {
      this.toggleMark = !this.toggleMark
    },
    // 获取球员信息
    getPlayerInfo() {
     this.$http.jsonp(`${ADDRESS.address}/combat-vote/player-list?award_id=${this.combat_vote_id}&award_type=${this.award_type}&callback=jsonp_1f182e856aa7dc0`).then(res => {
       this.playerlist = res.data.data
     })
    },
    // 获取活动信息
    getAwardList() {
     this.$http.jsonp(ADDRESS.address+'/combat-vote/award-list?combat_vote_id=6&callback=jsonp_14f80ff32a892c').then(res => {
       if (res.data.data && res.data.data[0] && res.data.data[0].list && res.data.data[0].list.length) {
        this.combat_vote_id = res.data.data[0].list[0].award_id
        this.award_type = res.data.data[0].list[0].award_type
        this.getPlayerInfo()
       }
     })
    },
    //投票
    voteGo(item) {
      if (!this.token) {
        this.login()
      } else {
        this.$http.jsonp(`${ADDRESS.address}/combat-vote/vote-go?award_type=${this.award_type}&player_id=${item.player_id}&token=${this.token}&callback=jsonp_3986ae5660d540`).then(res => {
          if (res.body.status == '40003') {
            this.showType = '1'
            this.toggle()
          } else if (res.body.status === 200) {
            this.count = res.data.data.num
            this.showType = '3'
            this.toggle()
             this.getPlayerInfo()
          } else if (res.body.status == '40001') {
            Toast('投票活动暂未开启')
          } else if (res.body.status === '40002') {
            Toast('投票活动已截止，感谢您的参与')
          } else if (res.body.status === '40004') {
            this.showType = '2'
            this.toggle()
          } else {
            Toast('投票失败，请重试')
          }
        })
      }
    },
    // 分享
    share() {
      this.$http.jsonp(`${ADDRESS.address}/combat-vote/share-config?combat_vote_id=6&token=${this.token}`).then(res => {
        let jumpUrl = window.location.origin + '/shareshop/#/tableTennisVoting'
        this.shareInfo = { des: res.body.data.subtitle, title: res.body.data.title || '陪国乒战东京', imageUrl: res.body.data.share_img || '', jumpUrl: jumpUrl || '' };
        this.gotoAPPShare()
      })
    },
    // 调用两端分享
    gotoAPPShare () {
      // 两端的分享方法
      try {
        window.webkit.messageHandlers.share.postMessage(this.shareInfo);
      } catch (e) {
        window.console.log("ios调用分享失败", this.shareInfo);
      }
      try {
        window.LiveAppJS.share(this.shareInfo.title, this.shareInfo.imageUrl, this.shareInfo.jumpUrl);
      } catch (e) {
        window.console.log("Android调用分享失败", this.shareInfo.title, this.shareInfo.imageUrl, this.shareInfo.jumpUrl);
      }
    },
    // 登录
    login() {
      try {
        window.webkit.messageHandlers.isnotlogin.postMessage('login');
      } catch (e) { window.console.log('') }
      try {
        window.LiveAppJS.login();
      } catch (e) { window.console.log('') }
    }
  }
}
</script>
<style lang="less" scoped>
@media screen and (min-width:750px) {
  body ,html{ font-size: 100px !important;}
}
.voting_wrap {
  height: auto;
  max-width: 7.5rem;
  min-height: 100%!important;
  margin: 0 auto;
  background: url("https://images.zhibo.tv/2021/0721/voting_bj.png") no-repeat;
  background-size: 100% 100%;
  font-family: OPPOSans;
  padding: .45rem 0 .36rem 0;
  box-sizing: border-box;
  position: relative;
  min-height: 100%;
}
.share_btn {
  position: absolute;
  right: 0;
  top: .41rem;
  height: .58rem;
  width: 1.06rem;
}
.voting_title {
  width: 100%;
  height: 2.74rem;
  display: flex;
  justify-content: center;
  img {
    height: 100%;
    width: 6.8rem;
    object-fit: contain;
  }
}
.hint_content {
  font-size: .24rem;
  font-family: OPPOSans;
  font-weight: normal;
  color: #FFFEFE;
  line-height: .47rem;
  padding: .14rem 1rem 0 1.04rem;
  box-sizing: border-box;
  text-align: center;
  span {
    display: blick;
  }
}
.athletes_voting {
  padding: 0 .38rem 0 .41rem;
  box-sizing: border-box;
  li {
    display: flex;
    height: .81rem;
    background: url(https://images.zhibo.tv/2021/0721/item_athletes_voting_bj.png) no-repeat;
    background-size: 100%;
    margin-top: .2rem;
    .left_athletes {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
      span {
        width: .69rem;
        height: .73rem;
        background: #A40C0E;
        box-shadow: 0px .02rem .01rem 0px #6F0000;
        border-radius: .1rem;
        text-align: center;
        line-height: .73rem;
        font-size: .34rem;
        font-family: OPPOSans;
        font-weight: normal;
        color: #F9CE54;
        margin-left: .02rem
      }
    }
    .center {
      flex: 1;
      display: flex;
      height: 100%;
      align-items: center;
      padding: 0 .33rem 0 .07rem;
      box-sizing: border-box;
      span {
        font-size: .32rem;
        font-family: OPPOSans;
        font-weight: normal;
        color: #661604;
        display: inline-block;
        min-width: 50%;
      }
      .player_box {
        display: flex;
        align-items: center;
        flex: 1;
        img {
          width: .71rem;
          height: .69rem;
          border-radius: 50%;
        }
        span {
          flex: 1;
          font-size: .32rem;
          // margin-left: .48rem;
          text-align: center;
        }
      }
      .voting_num {
        width: 1.84rem;
        font-size: .34rem;
        font-family: OPPOSans;
        font-weight: normal;
        color: #661604;
        span {
          text-align: left;
        }
        img {
          width: .35rem;
          height: .31rem;
          position: relative;
          top: .035rem;
          display: inline-block;
          margin-right: .09rem;
        }
      }
    }
    .right {
      // padding: .03rem 0;
      // box-sizing: border-box;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.11rem;
        height: .81rem;
        background: #F9CE54;
        box-shadow: 0px .02rem .07rem 0px rgba(111, 0, 0, 0.41);
        border-radius: .10rem;
        font-size: .23rem;
        font-family: OPPOSans;
        font-weight: normal;
        color: #C7151C;
      }
      .already_voting {
        background: #890605;
        color: #FFFFFF;
      }
    }
  }
}
.activity_ended_description {
  margin-top: .61rem;
  font-size: .2rem;
  font-family: OPPOSans;
  font-weight: normal;
  color: #FFFFFF;
  line-height: .3rem;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.footer_chinasports_icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: .28rem;
  img {
    width: .84rem;
    height: .94rem;
  }
}
</style>
<style lang="less">
body {
  background: #A10B0D!important;
}
</style>
